import { render, staticRenderFns } from "./ListGoods.vue?vue&type=template&id=11a078fa&scoped=true&"
import script from "./ListGoods.vue?vue&type=script&lang=js&"
export * from "./ListGoods.vue?vue&type=script&lang=js&"
import style0 from "./ListGoods.vue?vue&type=style&index=0&id=11a078fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a078fa",
  null
  
)

export default component.exports